import React from 'react';
import { connect } from 'react-redux';
import { Box, CircularProgress, withStyles } from '@material-ui/core';

const styles = (theme) => ({
  loading: {
    position: 'fixed',
    top: '0px',
    left: '0px',
    height: '100%',
    width: '100%',
    zIndex: 11,
  },
  tableParent: {
    display: 'table',
    height: '100%',
    width: '100%',
  },
  tableParentCell: {
    display: 'table-cell',
    height: '100%',
    width: '100%',
    verticalAlign: 'middle',
    textAlign: 'center',
  },
});

class Loader extends React.Component {

  render() {
    const { classes, loading, isSwitcherOpen, loaderDarkTheme } = this.props;
    const darkLoader = loaderDarkTheme || !isSwitcherOpen;

    if (!loading) return null;

    return (
      <Box data-testid="loader" className={classes.loading}>
        <Box className={classes.tableParent}>
          <Box className={classes.tableParentCell}>
            {darkLoader ? (
              <CircularProgress />
            ) : (
              <CircularProgress style={{ color: 'white' }} />
            )}
          </Box>
        </Box>
      </Box>
    );
  }
}

const mapState = (state) => {
  return {
    loading: state.loading,
    loaderDarkTheme: state.loaderDarkTheme,
    isSwitcherOpen: state.switcher.isSwitcherOpen,
  };
};

export default connect(mapState)(withStyles(styles)(Loader));
